import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';

// Import all slices
import {
  authenticationReducer,
  attributeReducer,
  brandReducer,
  contentReducer,
  dialogReducer,
  financeReducer,
  galleryReducer,
  itemLandingReducer,
  itemProductReducer,
  landingReducer,
  marketerReducer,
  notificationReducer,
  ordersReducer,
  ordersMajorReducer,
  packageTypeReducer,
  periodReducer,
  productReducer,
  regionReducer,
  requestsReducer,
  rewardsReducer,
  roleReducer,
  settingReducer,
  ticketReducer,
  transactionReducer,
  treeReducer,
  userReducer
} from './reducers';

const rootReducer = combineReducers({
  authReducer: authenticationReducer,
  attribute: attributeReducer,
  brandReducer: brandReducer,
  contentReducer: contentReducer,
  dialogReducer: dialogReducer,
  financeReducer: financeReducer,
  galleryReducer: galleryReducer,
  itemLandingReducer: itemLandingReducer,
  itemProductReducer: itemProductReducer,
  landing: landingReducer,
  marketer: marketerReducer,
  notification: notificationReducer,
  orders: ordersReducer,
  ordersMajor: ordersMajorReducer,
  packageTypeReducer: packageTypeReducer,
  period: periodReducer,
  productReducer: productReducer,
  region: regionReducer,
  requests: requestsReducer,
  rewards: rewardsReducer,
  roleReducer: roleReducer,
  settingReducer: settingReducer,
  ticketReducer: ticketReducer,
  transaction: transactionReducer,
  treeReducer: treeReducer,
  userReducer: userReducer
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['authReducer'] // Only auth will be persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ['persist/PERSIST'],
          ignoredPaths: ['auth.expiration']
        },
      })
});

const persistor = persistStore(store);

export { store, persistor };